import React from 'react'

import { SafeRetirementIndicator } from '@components/SafeRetirementIndicator'
import { CardFooter } from '@components/layout/Card'

export const JointSafeRetirementIndicator = ({ participantsQueries, timeValue }) => {
  const safeRetirementPropsPerParticipant = participantsQueries.map((participantQuery) => {

    const safeRetirementStatus = participantQuery?.forecast.data.baseScenario.safeRetirementStatus
    const participantCurrentAge = participantQuery?.participant.currentAge

    const capitalProps = {
      capitalForPossibly: participantQuery?.forecast.data.baseScenario.capitalRequirements.capitalForSafeRetirementBrackets.possibly,
      capitalForLikely: participantQuery?.forecast.data.baseScenario.capitalRequirements.capitalForSafeRetirementBrackets.likely,
      capitalAtRetirement: participantQuery?.forecast.data.baseScenario.capitalRequirements.projectedCapitalAtRetirement,
      inflation: participantQuery?.scenario.data.baseScenario.assumptions.inflation,
      yearsToRetirement: participantQuery?.scenario.data.baseScenario.retirementAge - participantCurrentAge,
      timeValue
    }
    return {
      participantId: participantQuery.participant.id,
      participantPreferredName: participantQuery.participant.preferredName,
      safeRetirementStatus,
      capitalProps
    }
  })
  return (
    <SafeRetirementIndicator>
      <SafeRetirementIndicator.Heading />
      {safeRetirementPropsPerParticipant.map((safeRetirementProps) => (
        <>
          <SafeRetirementIndicator.Indicator
            key={`${safeRetirementProps.participantId}-safe-retirement-status`}
            safeRetirementStatus={safeRetirementProps.safeRetirementStatus}
          />
          <SafeRetirementIndicator.CapitalRequirementsCardExtension
            key={`${safeRetirementProps.participantId}-capital-requirements`}
            capitalProps={safeRetirementProps.capitalProps}
            headingText={`${safeRetirementProps.participantPreferredName}'s capital requirements`}
          />
        </>
      ))}
      <CardFooter>
        <p style={{
          marginBlockEnd: 0,
          fontSize: '0.85rem',
          lineHeight: '1.4'
        }}>
          👋 We're busy working on a joint indicator, but in the meantime,&nbsp;
          <a style={{
            letterSpacing: 'unset',
            textTransform: 'unset',
            fontWeight: 'normal'
          }} onClick={() => Intercom("showNewMessage")}>let us know </a>what you think of joint planning.
        </p>
      </CardFooter>
    </SafeRetirementIndicator>
  )
}
